var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"info",staticClass:"explanation",attrs:{"src":require("../assets/icons/question-circle.svg"),"data-bs-toggle":"tooltip","title":_vm.title,"alt":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }